import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import { LoadingSpinner } from '../components/LoadingSpinner';

interface AuthGuardProps {
  children: React.ReactNode;
  redirectTo?: string;
}

// Для страниц, которые должны быть доступны только НЕавторизованным (login, register)
export function PublicOnlyRoute({ children, redirectTo = '/dashboard' }: AuthGuardProps) {
  const { isAuthenticated, isLoading, needsRoleSelection, isEmailVerified } = useAuth();
  const location = useLocation();

  console.log('[AuthGuard/PublicOnlyRoute] ========== START ==========');
  console.log('[AuthGuard/PublicOnlyRoute] Pathname:', location.pathname);
  console.log('[AuthGuard/PublicOnlyRoute] isLoading:', isLoading);
  console.log('[AuthGuard/PublicOnlyRoute] isAuthenticated:', isAuthenticated);
  console.log('[AuthGuard/PublicOnlyRoute] needsRoleSelection:', needsRoleSelection);
  console.log('[AuthGuard/PublicOnlyRoute] isEmailVerified:', isEmailVerified);

  if (isLoading) {
    console.log('[AuthGuard/PublicOnlyRoute] RETURN: LoadingSpinner');
    return <LoadingSpinner />;
  }

  if (isAuthenticated) {
    console.log('[AuthGuard/PublicOnlyRoute] User is authenticated, checking redirects...');
    
    // СНАЧАЛА проверяем верификацию email - это важнее чем выбор роли
    // Пользователь должен подтвердить email перед выбором роли
    if (!isEmailVerified) {
      console.log('[AuthGuard/PublicOnlyRoute] RETURN: Navigate to /verify-email-pending (email not verified)');
      return <Navigate to="/verify-email-pending" replace />;
    }
    
    // Если email верифицирован - проверяем нужен ли выбор роли
    if (needsRoleSelection) {
      console.log('[AuthGuard/PublicOnlyRoute] RETURN: Navigate to /role-selection (needsRoleSelection)');
      return <Navigate to="/role-selection" replace />;
    }
    
    console.log('[AuthGuard/PublicOnlyRoute] RETURN: Navigate to', redirectTo);
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  console.log('[AuthGuard/PublicOnlyRoute] RETURN: Children (not authenticated)');
  return <>{children}</>;
}

// Для страниц, доступных только авторизованным
export function PrivateRoute({ children, redirectTo = '/login' }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  console.log('[AuthGuard/PrivateRoute] ========== START ==========');
  console.log('[AuthGuard/PrivateRoute] Pathname:', location.pathname);
  console.log('[AuthGuard/PrivateRoute] isLoading:', isLoading);
  console.log('[AuthGuard/PrivateRoute] isAuthenticated:', isAuthenticated);

  if (isLoading) {
    console.log('[AuthGuard/PrivateRoute] RETURN: LoadingSpinner');
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    console.log('[AuthGuard/PrivateRoute] RETURN: Navigate to', redirectTo);
    return <Navigate to={redirectTo} replace />;
  }

  console.log('[AuthGuard/PrivateRoute] RETURN: Children');
  return <>{children}</>;
}
